module.exports = __webpack_public_path__ + "static/media/logo-light.7e400e54.svg";